export default [
  {
    path:'/admin/order/list',
    name:'OrderList',
    component:()=>import('../views/order/list'),
    meta:{
      title:'订单列表'
    }
  },
  {
    path:'/admin/order/sales/list',
    name:'SalesOrderList',
    component:()=>import('../views/order/SalesOrderList'),
    meta:{
      title:'123'
    }
  },
  {
    path:'/admin/order/list/details',
    name:'OrderDetails',
    component:()=>import('../views/order/order_details'),
    meta:{
      title:'订单详情'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/order.js